type RoomState = "waiting" | "started" | "finished";

export const TILE_STATE = {
  EMPTY: "",
  GAP: "G",
  PAWN: "P",
  ROOK: "R",
  BISHOP: "B",
  KNIGHT: "N",
  KING: "K",
  QUEEN: "Q",
} as const;
export type TileState = (typeof TILE_STATE)[keyof typeof TILE_STATE];

export const PLAYER_COLOR = {
  NONE: "",
  BLACK: "B",
  WHITE: "W",
} as const;
export type PlayerColor = (typeof PLAYER_COLOR)[keyof typeof PLAYER_COLOR];

export type PieceImage = string;

export type BoardSquareID = `${string}:${string}`;
export type BoardSquareData = {
  state: TileState;
  color: PlayerColor;
  image?: PieceImage;
  lastMoveOnTurn?: number;
};

export function getSquareId(
  rowIndex: number,
  columnIndex: number
): BoardSquareID {
  return `${rowIndex}:${columnIndex}`;
}

export function getReversedSquareId(
  rowIndex: number,
  columnIndex: number
): BoardSquareID {
  return `${7 - rowIndex}:${7 - columnIndex}`;
}
